$(window).bind("popstate", function change(e) {
	var hash = window.location.hash.substring(1);
	menuToggles( $('#'+hash) );
	$('.menu-filter-link').removeClass('active');
	$('.menu-filter-link[href="#'+hash+'"]').addClass('active');
});

var $grid;

$(function() {
	// Menu Filters
	if( $('body .menu-filters').length ){
		var menufiltersTop = $(".menu-filters").offset().top;
		var navigationHeight = $("nav.header").outerHeight();
		var ogMenuNav = $(".menu-filters");

		var menuNavClone = ogMenuNav.clone(true).appendTo('nav.header').removeClass('alignwide').css({"position": "relative", "z-index": "9"}).wrap( "<div class='header-menu-filters'><div class='container'></div></div>" );
		menuNavClone.hide();

		$grid = $('.menu-group.fill').masonry({
			itemSelector: '.menu-item',
			columnWidth: '.menu-item',
			percentPosition: true,
			transitionDuration: 0,
			horizontalOrder: true
		});

		if(window.location.hash) {
			var hash = window.location.hash.substring(1);
			menuToggles( $('#'+hash) );
			$('.dropdown-toggle').html($('a[href="#'+hash+'"]').html());
			$('.menu-filter-link[href="#'+hash+'"]').parent().addClass('active');
			if( $('#'+hash).is(':last-child') ){
				$('#next-menu').hide();
			}else if( $('#'+hash).is(':first-child') ) {
				$('#prev-menu').hide();
			}
		} else {
			menuToggles( $('.menu-section-container').first() );
			$('.menu-categories').each(function(index, element){
				$(element).find('li').first().addClass('active');
			});

			$('#prev-menu').hide();
		}

		$('.menu-filter-link').on('click', function(event){
			event.preventDefault();
			var $this = $(this);
			$('.dropdown-toggle').html($this.html());
			$('.menu-categories li').removeClass('active');

			if ( $( window ).width() < 600 ) {
				$('.menu-categories').slideUp();
			};

			$('a.menu-filter-link[href="'+ $this.attr('href') +'"]').parent().addClass('active');

			menuToggles( $( $this.attr('href') ) );
			history.pushState(null, null, $this.attr('href'));

			$('#next-menu').show();
			$('#prev-menu').show();

			if( $this.parent().is(':last-child') ) {
				$('#next-menu').hide();
			} else if( $this.parent().is(':first-child') ) {
				$('#prev-menu').hide();
			}

			$([document.documentElement, document.body]).animate({
				scrollTop: $('#main').offset().top
			}, 1000);

		});

		$(window).on('scroll', function() {
			if ( window.pageYOffset >= menufiltersTop - navigationHeight ) {
				menuNavClone.show();
				menuFilterStyles();
				ogMenuNav.css('opacity', 0);
				$('nav.header').css('transform', 'translateY(-'+navigationHeight+'px)');
			} else {
				menuNavClone.hide();
				menuFilterStyles();
				ogMenuNav.css('opacity', 1);
				$('nav.header').css('transform', 'translateY(0px)');
			}
		})

		$('.menu-navigation-link').on('click', function(event){
			event.preventDefault();
			var $target;
			if( $(this).data('target') == 'prev' ){
				$target = $('.menu-categories li.active').prev();
			} else if ( $(this).data('target') == 'next' ) {
				$target = $('.menu-categories li.active').next();
			}

			$('.menu-categories li').removeClass('active');
			$target.addClass('active');
			menuToggles( $($target.find('a').attr('href')) );
			history.pushState(null, null, $target.find('a').attr('href'));
			$('.dropdown-toggle').html($target.find('a').html());

			if($target.is(':last-child')){
				$('#next-menu').hide();
				$('#prev-menu').show();
			} else if ($target.is(':first-child')) {
				$('#next-menu').show();
				$('#prev-menu').hide();
			} else {
				$('#next-menu').show();
				$('#prev-menu').show();
			}

			$([document.documentElement, document.body]).animate({
				scrollTop: $('#main').offset().top
			}, 1000);
		});

	}

})

$('.dropdown-toggle').on('click', function() {
	$('.menu-categories').slideToggle();
	$(this).toggleClass('open');
})

$( window ).resize(function() {
	if( $('body .menu-filters').length ){
		menufiltersTop = $(".menu-filters").offset().top;
		navigationHeight = $("nav.header").outerHeight();
		menuFilterStyles();

	}
});

$( window ).on('load', function() {
	if( $('body .menu-filters').length ){
		menuFilterStyles();
	}
});

function menuToggles(showTarget){
	$('.menu-section-container').addClass('hide').removeClass('show');
	if(!!showTarget || showTarget === '') {
		showTarget.addClass('show').removeClass('hide');
		$grid.masonry('layout');
	}
}

function menuFilterStyles() {
	// Reset Styles
	$('ul.menu-categories li').css('border-color', 'transparent');

	// Loop through menu items
	$('ul.menu-categories').each(function(index, element){
		// Init Arrays
		var menuCategories = [];

		$(element).find('li').each(function(index, element) {
			var offset = $(element).offset();

			// If the item has a new height position flag it
			if (menuCategories.indexOf(offset.top) === -1) {
				menuCategories.push(offset.top);
			} else {
				$(element).css('border-color', '#b4292e');
			}
		})

	});
}
